"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopNavLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./TopNavLayout.css");
var Row_1 = require("../../components/Row");
var CJLogo_1 = require("../../components/CJLogo");
var classnames_1 = __importDefault(require("classnames"));
var Box_1 = require("../../components/Box");
var Stack_1 = require("../../components/Stack");
var Button_1 = require("../../components/Button");
var MDIcon_1 = require("../../components/MDIcon");
var TopNavLayout = function (_a) {
  var className = _a.className,
    title = _a.title,
    _b = _a.actions,
    actions = _b === void 0 ? {} : _b,
    _c = _a.positionAbsolute,
    positionAbsolute = _c === void 0 ? false : _c,
    contentProps = _a.contentProps,
    width = _a.width,
    height = _a.height,
    children = _a.children,
    restProps = __rest(_a, ["className", "title", "actions", "positionAbsolute", "contentProps", "width", "height", "children"]);
  var cn = (0, classnames_1.default)("vsx-top-nav-layout", positionAbsolute && "vsx-top-nav-layout-absolute", className);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    className: cn,
    style: __assign(__assign({}, restProps.style), {
      width: width,
      height: height
    })
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      align: "center",
      paddingLeft: "medium",
      paddingRight: "medium",
      justify: "space-between",
      className: "vsx-top-nav-layout-topnav"
    }, {
      children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        align: "center",
        gap: "medium",
        className: "vsx-top-nav-layout-branding"
      }, {
        children: [(0, jsx_runtime_1.jsx)(CJLogo_1.CJLogo, {
          className: "vsx-top-nav-layout-logo"
        }), (0, jsx_runtime_1.jsx)("h1", __assign({
          className: "vsx-top-nav-layout-title"
        }, {
          children: title
        }))]
      })), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        align: "center",
        gap: "large",
        className: "vsx-top-nav-layout-actions"
      }, {
        children: [actions.back && (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
          align: "center",
          gap: "small",
          className: "vsx-top-nav-layout-action",
          onClick: actions.back.onClick,
          paddingRight: "medium"
        }, {
          children: [(0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
            size: 20,
            icon: "arrow-left"
          }), (0, jsx_runtime_1.jsx)("span", {
            children: actions.back.content
          })]
        })), actions.cancel && (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
          type: "tertiary",
          className: "vsx-top-nav-layout-cancel-action",
          onClick: actions.cancel.onClick
        }, {
          children: actions.cancel.content
        })), actions.submit && (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
          type: "primary",
          onClick: actions.submit.onClick
        }, {
          children: actions.submit.content
        })), actions.help && (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
          align: "center",
          gap: "small",
          className: "vsx-top-nav-layout-action",
          onClick: actions.help
        }, {
          children: [(0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
            size: 20,
            icon: "help-circle-outline"
          }), "Help"]
        })), actions.close && (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
          icon: "close",
          size: 20,
          className: "vsx-top-nav-layout-action",
          onClick: actions.close
        })]
      }))]
    })), (0, jsx_runtime_1.jsx)(Box_1.Box, __assign({}, contentProps, {
      className: (0, classnames_1.default)("vsx-top-nav-layout-content", contentProps === null || contentProps === void 0 ? void 0 : contentProps.className)
    }, {
      children: children
    }))]
  }));
};
exports.TopNavLayout = TopNavLayout;